// extracted by mini-css-extract-plugin
export default {"ChartCardDescriptionText":"Description-module__ChartCardDescriptionText--ORwU6"};